import api from "./core";

const basePath = "api/{{serverSegment}}/Forms";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  },
  getVersions(id) {
    return api.get(`${basePath}/${id}/Versions`);
  },
  update(id, data) {
    return api.patch(`${basePath}/${id}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  query(filter) {
    return api.post(`${basePath}/${filter.category}${ filter.eocId ? "?eocId=" + filter.eocId : "" }`);
  },
  create(data) {
    return api.put(`${basePath}`, data);
  },
  viewScoringInstructionsUrl(id) {
    return `${api.getFormsBaseUrl()}${basePath}/DownloadScoringInstructions/${api.getToken()}/${id}`;
  },
  uploadScoringInstructions(id, file) {
    const formData = new FormData();
    formData.append("File", file);

    return api.put(`${basePath}/UploadScoringInstructions/${id}`, formData, {
      headers: {
        "content-type": "multipart/form-data"
      }
    });
  },
  deleteScoringInstructions(id) {
    return api.put(`${basePath}/DeleteScoringInstructions/${id}`);
  },
  updateLastTimeEditing(id) {
    return api.patch(`${basePath}/${id}/last-edit-time`, {},
    {
      "Hide-Loading": true
    });
  },
};
